
/**
* $.fn.elmetrics
*
* Plugin for wrapping coremetrics and omniture
*
* @version v1.0.3, 2015-6-26
* @author Fredi Quirino <fred@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2012 Firefall Pro, LLC
*/
/*jshint strict:true */
/*global jQuery:true, cmCreatePageElementTag:true, cmCreatePageviewTag:true, s:true*/
(function ($) {
	'use strict';
	var defaults = {
		options : {
			// @param {String} CAT ID, defaulting to 'CAT'
			cat_id : 'CAT',
			// @param {String} Boutique Name, defaulting to 'Boutique Name'
			element_cat : 'Boutique Name',
			// @param {Boolean} Debug, defaulting to 'false'
			debug : false,
			// @param {String} To avoid non-interactive clicks from triggering the analytics you can optionally pass a string to the .trigger method and the plugin will ignore it, defaulting to 'ignore'
			ignore_event_namespace : 'ignore',
			// @param {String} Flag to force either core-metrics (1) or omniture (2)
			force : 0
		},
		// @param {Array} Array is filled once the plugin is initialized, used to easily output a list that can be copy and pasted into a rollout kit.
		log_elements : [],
		
		// 0 = silent, 1 = cm, 2 = omniture
		state : 0 
	};
	
	var settings, init = false;
	
	function _log() {
		if (!settings.options.debug) return;
		
		var ie = !$.support.opacity, args = arguments, str = '';
		
		if (ie && typeof arguments[0] === 'string' && typeof arguments[1] === 'string') str = arguments[0] + ' ' + arguments[1];
		else if (ie && typeof arguments[0] === 'string') str = arguments[0];
		
		console.log('jQuery.ElMetrics', (ie) ? str : args);
	}
	
	function check_current_metrics() {
		
		_log('checking what metrics are available', settings.options.force);
		
		if (typeof window.s !== 'undefined' && (!settings.options.force || settings.options.force === 2)) {
			settings.state = 2;
			
		} else if (typeof cmCreatePageElementTag !== 'undefined' && typeof cmCreatePageviewTag !== 'undefined' && (!settings.options.force || settings.options.force === 1)) {
			settings.state = 1;
		}
		
		_log('state set to ' + settings.state);
	}
	function handle_view(target, view) {
		
		_log('handle_view:', target, view);
		var index = target - 1, title;
		
		if (index < 0 || index > settings.section.length) {
			_log('handle_view: index is invalid');
			return;
		}
		
		view = !view ? '' : ' : ' + view;
		title = settings.options.element_cat + ' : ' + settings.section[index].tag + view;
		
		_log('PageView Triggered: ' + title);
		
		check_current_metrics();
		
		if (settings.state === 2) {
			// ** does it care that we only give it 2 (e.g boutique name | Section Name) instead of 3 (e.g boutique name | Section Name | View)
			var omni_value = title.replace(/:/g, '|');
			_log('Omniture Value - ' + omni_value);
			
			// add omniture stuff
			s.linkTrackVars = 'eVar26,prop16';
			s.eVar26 = omni_value;
			s.prop16 = 'D=v26';
			s.tl();
			// reset the value since the next tag omniture throws which is not ours, seems to display the same value as eVar26
			s.eVar26 = '';
		
		} else if (settings.state === 1) {
			cmCreatePageviewTag(title, null, settings.options.cat_id, null, null);
		}
	}
	function handle_event(event, $element, value) {
		
		if ($element.length) {
			$element.on(event + '.elmetrics', function (e, ignore_flag) {
				_log('element in section triggered - ' + event, ignore_flag);
				
				_log('Event Triggered: ' + value);
			
				if (ignore_flag && ignore_flag === settings.options.ignore_event_namespace) {
					_log('element will be ignored');
					return;
				}
				
				check_current_metrics();
				
				if (settings.state === 2) {
					// ** does it matter that value will sometimes produce more than the 3 parameters shown in the excel.
					var omni_value = value.replace(/:/g, '|');
					_log('Omniture Value - ' + omni_value);
					
					// add omniture stuff
					s.linkTrackVars = 'eVar26,prop16';
					s.eVar26 = omni_value;
					s.prop16 = 'D=v26';
					s.tl('o');
					// reset the value since the next tag omniture throws which is not ours, seems to display the same value as eVar26
					s.eVar26 = '';
				
				} else if (settings.state === 1) {
					cmCreatePageElementTag(value, settings.options.element_cat, null);
				}
			});
		}
	}
	
	$.fn.elmetrics = function (o) {
		
		
		// merge settings
		settings = $.extend(true, {}, defaults, o);
		
		_log('initializing');
		
		// only run once
		if (init) {
			_log('plugin has already been initialized');
			return;
		}
		
		// jquery object for container
		settings.$el = typeof this === 'function' ? $('body') : $(this);
		
		// validate: section exists
		if (typeof settings.section === 'undefined') {
			_log('sections are not defined');
			return;
		}
		
		init = true;
		
		// Bind for page views
		$('body').on('page_view', function (event, target, view) {
			// validate: target needs to 1 or greater
			if (!target) return;
			
			handle_view(target, view);
		});
		
		// iterate through all the sections defined and add events for clicks
		for (var i = 0; i < settings.section.length; i++) {	
			var section = settings.section[i];
			
			// validate: expected property
			if (typeof section.element_tag === 'undefined') {
				_log('Section ' + (i + 1) + ': does not have element_tag object defined');
				continue;
			}
			// bind elements defined in this section
			for (var index in section.element_tag) {
				if (section.element_tag.hasOwnProperty(index)) {
					var value = section.element_tag[index],
						tag_string = '';
					
					// value is not a string, has options
					if (typeof value === 'object') {
						_log('Element tag has an object instead of a string');
						
						var log_value = '',//prevent logging multiple events for a single selector
							event_value = '';
							
						for (var event in value) {
							if (value.hasOwnProperty(event)) {
								_log('Element Tag Options: event - ' + event);
								
								event_value = value[event];
								tag_string = settings.options.element_cat + ' : ' + section.tag + ' : ' + event_value;
								
								// prefer 'click' if it exists, otherwise any 1 event will do
								log_value = !log_value ? tag_string : log_value;
								log_value = event === 'click' ? tag_string : log_value;
								
								// method that will do the binding
								handle_event(event, settings.$el.find(index), tag_string);	
							}
						}
						
						tag_string = log_value;
					} else {
						tag_string = settings.options.element_cat + ' : ' + section.tag + ' : ' + value;
						
						// method that will do the binding
						handle_event('click', settings.$el.find(index), tag_string);	
					}
					
					
					
					// add element to the log
					var el_id = settings.$el[0].id ? '#' + settings.$el[0].id : '';
					settings.log_elements.push('\'' + el_id + ' ' + index + '\' : \'' + tag_string + '\'');
					
				}
			}
		}
		
		/*
		Notes: data-elmetrics should contain metrics data in this format :
		
		<BOUTIQUE NAME> : <ITEM DETAIL 1> : <ITEM DETAIL 2> : <ITEM DETAIL N> : ... (etc, more as needed)
		
		example:
			Random Boutique : A part of this random boutique : Descriptive name of said element being clicked
		
		*/
		var $inline_elements = settings.$el.find('[data-elmetrics]');
		$inline_elements.each(function () {
			var $this = $(this);
			var value = $this.data('elmetrics');// inline require the tag to include boutique name, and such. since 'section.tag' is not available at this point
			
			// invalid value, skip
			if (!value) return true;
			
			// unbind older elements, inline overrides js object
			$this.off('click.elmetrics');
			
			//var tag_string = settings.options.element_cat + ' : ' + section.tag + ' : ' + value;
			handle_event($this, value);
		});
		
	};
	$.fn.elmetrics.outputElements = function () {
		// only works in debug
		if (!settings.options.debug) return;
		
		for (var i = 0; i < settings.log_elements.length; i++) {
			console.log(settings.log_elements[i]);
		}
	};
	// Alias
	$.elmetrics = $.fn.elmetrics;
	$.elmetrics.outputElements = $.fn.elmetrics.outputElements;
})(jQuery);
